import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "../defaults";

import {
    Group,
    ICustomer,
    INewPartner,
    IPartner,
    PartnerHistory,
} from "store/partners/partners-types";

export const loadPartners = async (): Promise<[IPartner[] | null, number]> => {
    const response = await API.get("/partners");

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const loadPartnerGroups = async (): Promise<
    [Group[] | null, number]
> => {
    const response = await API.get("/partners/aad-groups");

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const loadUserLinkedPartners = async (): Promise<
    [IPartner[] | null, number]
> => {
    const response = await API.get("/partners/user-linked");

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const addPartner = async (
    partner: INewPartner
): Promise<[null, number]> => {
    const response = await API.post("/partners", partner);

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const deletePartner = async (
    partnerId: string
): Promise<[null, number]> => {
    const response = await API.delete(`/partners/${partnerId}`);

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const loadPartnerHistory = async (
    partnerId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[PartnerHistory | null, number]> => {
    const response = await API.get(`/partners/${partnerId}/history`);

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadCustomers = async (): Promise<
    [ICustomer[] | null, number]
> => {
    const response = await API.get("/partners/customers");

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
